import React from "react";
import Autocomplete from "react-google-autocomplete";
import { useRef, useEffect, useState } from "react";
import { fetchApiKey } from "../utils/apiUtils";
import { FaSpinner } from "react-icons/fa"; // Import spinner icon

const AddressInput = ({ value, onAddressSelect, onChange, id, placeholder }) => {
  const inputRef = useRef(null);
  const [apiKey, setApiKey] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    handleFetchApiKey();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Sync the input from the `value` prop only when it differs from what's shown
  // (e.g. filled by "use my current location"), NOT on every keystroke - that
  // would fight the user's typing and jump the caret. This is what lets the
  // field stay freely editable after being auto-filled.
  useEffect(() => {
    if (
      inputRef.current &&
      value !== undefined &&
      value !== inputRef.current.value
    ) {
      inputRef.current.value = value;
    }
  }, [value]);

  const handlePlaceSelect = (place) => {
    if (place && place.formatted_address) {
      const address = place.formatted_address;
      // Also surface coordinates when the Places result carries them, so
      // callers can store lat/lng for proximity features (Safety Check-In's
      // "you're near a saved address" nudge). Older saved addresses have no
      // coordinates and simply won't trigger proximity - manual check-in still
      // works for them.
      let coords = null;
      if (place.geometry && place.geometry.location) {
        coords = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        };
      }
      onAddressSelect(address, coords); // Pass the address to the parent
    }
  };

  const handleFetchApiKey = async () => {
    try {
      const key = await fetchApiKey(); // Fetch the API key
      setApiKey(key); // Set the key in state
    } catch (err) {
      console.error("Error fetching API key:", err);
      setError("Failed to fetch API key.");
    }
  };

  return (
    <>
      {apiKey ? (
        <Autocomplete
          apiKey={apiKey}
          onPlaceSelected={handlePlaceSelect}
          onChange={onChange}
          options={{
            types: ["address"], // Restricts to addresses
            //componentRestrictions: { country: "us" }, // Limit to a specific country, e.g., US
          }}
          ref={inputRef}
          id={id}
          placeholder={placeholder}
          style={{
            width: "90%",
            padding: "10px 15px",
            borderRadius: "20px",
            border: "1px solid var(--border-color, #ccc)",
            backgroundColor: "var(--input-bg, #fff)",
            color: "var(--text-primary, #000)",
          }}
        />
      ) : error ? (
        <p style={{ color: "red" }}>{error}</p>
      ) : (
        <FaSpinner size={20} className="spin" />
      )}
    </>
  );
};

export default AddressInput;
